/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/order */
/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import style from './listing.module.scss';
import Pictures from './pictures/pictures';
import '../../constants/_global.scss';
import FavoriteButton from '../../UI/favoriteButton/favoriteButtonComponent';
import Description from './description/description';
import Line from '../../UI/line/line';
import { ReactComponent as MapPin } from '../../assets/mapPin.svg';
import Contact from './contact/contact';
import { ListingInterface } from './listingTypes';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from '../../index';
import { ListingDataInterface } from '../../constants/constants';
import { deleteListing, like, setFavoriteOnCard, unlike } from '../../service/ListingData';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const fakeNumber = '+7 (916) 332-55-42 (Олег)';
const defaultData = {
  id: 0,
  img1: null,
  img2: null,
  img3: null,
  name: '',
  category: '',
  condition: '',
  city: '',
  description: '',
  price: 0,
  owner: 0,
  isOwner: false,
  isFavorite: false,
  ownerUsername: '',
  ownerEmail: '',
}

const Listing: React.FC<ListingInterface> = ({  toEdit, toLogin }) => {
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 1200 }),
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLogin = useSelector((state) => state.userData.isLogin);
  const userId = useSelector((state) => state.userData.user.id)
  const {id} = useParams() as {id: string}
  const storeData = useSelector((state) => state.listingData.listings?.find(l => l.id.toString() === id))
  const [data, setData] = useState<ListingDataInterface>(defaultData)
  const [owner, setOwner] = useState<boolean>(false);

  useEffect(() => {
    if (storeData) {
      setData(storeData)
    }
  }, [storeData, id])

  useEffect(() => {
    if (data.owner === userId) {
      setOwner(true)
    } else {
      setOwner(false)
    }
  }, [userId, data])
  const contact = `${data.ownerEmail} (${data.ownerUsername})`
  const span = `${data?.category}•${data?.condition}`;
  const formatPrice = data?.price
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const stringChecker = (photo: any) => {
    if (typeof photo === 'string') {
      return photo;
    }
    return null; 
  };


  const setFavorite = () => {
    if (storeData!.isFavorite) {
      dispatch(unlike(storeData!.id));
      dispatch(setFavoriteOnCard(storeData!.id))
    } else {
      dispatch(like(storeData!.id));
      dispatch(setFavoriteOnCard(storeData!.id))

    }
  };

  const descriptionExtraClass = resolution.DesktopOrLaptop
    ? style.exDescription
    : null;

  const shellStyle = resolution.DesktopOrLaptop
    ? style.shell
    : style.shellMobile;

  const lineWidth = resolution.DesktopOrLaptop ? 648 : 1100;
  
  const handleDelete = () => {
    dispatch(deleteListing(data.id))
    navigate('/');
  }

  const editListing = () => {
    toEdit(data.id)
  }



  return (
    <div className={shellStyle}>
      {resolution.DesktopOrLaptop ? (
        <Pictures
          photoOne={stringChecker(data.img1)}
          photoTwo={stringChecker(data.img2)}
          photoThree={stringChecker(data.img3)}
        />
      ) : null}
      <div className={style.spaceBetween}>
        <div className={style.description}>
          {(resolution.DesktopOrLaptop && !owner && isLogin) ? (
            <div className={style.favorite}>
              <FavoriteButton alreadyFavorite={storeData?.isFavorite || false} onClick={setFavorite} disabledStatus={isLogin}/>
              <h2 className="h2">В избранное</h2>
            </div>
          ) : null}
          <span className={`${style.categoryColor} spanGlobal`}>{span}</span>
          <Description
            title={data.name}
            description={data.description}
            extraClass={descriptionExtraClass}
            childOne={ !owner && !resolution.DesktopOrLaptop && isLogin ?
              <div className={style.favoriteMobile}>
                <FavoriteButton alreadyFavorite={storeData?.isFavorite || false} onClick={setFavorite} disabledStatus={isLogin}/>
                <h2 className="subtitle">В избранное</h2>
              </div> : null
             }
            childTwo={
              <Pictures
                photoOne={stringChecker(data.img1)}
                photoTwo={stringChecker(data.img2)}
                photoThree={stringChecker(data.img3)}
              />
            }
          />
          <Line width={lineWidth} height={1} />
          <div
            className={
              resolution.DesktopOrLaptop
                ? style.adressPrice
                : style.adressPriceMobile
            }
            style={
              !resolution.DesktopOrLaptop
                ? { margin: '40px 0 40px 0' }
                : { margin: '0' }
            }
          >
            <div
              className={
                resolution.DesktopOrLaptop
                  ? style.favorite
                  : style.favoriteMobile
              }
            >
              <MapPin />
              <h3 className="subtitle">{data.city}</h3>
            </div>
            <h1 className={`h1 ${style.exContact}`}>{`${formatPrice} ₽`}</h1>
          </div>
          {!resolution.DesktopOrLaptop ? (
            <Line width={lineWidth} height={1} />
          ) : null}
          {/* <Contact number={fakeNumber} extraClass={style.exContact} /> */}
        </div>
        <Contact
          number={contact}
          extraClass={style.exContact}
          isOwner={userId === data.owner}
          isLogin={isLogin}
          toDelete={handleDelete}
          toEdit={editListing}
          toLogin={toLogin}
        />
      </div>
    </div>
  );
};

export default Listing;
